
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcMosfet as ObcMosfetElement} from '@oicl/openbridge-webcomponents/dist/automation/mosfet/mosfet.js';
 
 
 

 
 export const ObcMosfet = createComponent({
   react: React,
   tagName: 'obc-mosfet',
   elementClass: ObcMosfetElement,
   events: {
     
   }
  });
 
 